import { render, staticRenderFns } from "./productivityV2.vue?vue&type=template&id=6800b881&scoped=true"
import script from "./productivityV2.vue?vue&type=script&lang=js"
export * from "./productivityV2.vue?vue&type=script&lang=js"
import style0 from "./productivityV2.vue?vue&type=style&index=0&id=6800b881&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6800b881",
  null
  
)

export default component.exports